// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { FullTextToolTip } from 'ui_kit_qmd'
import './VisitCard.scss'
import moment from 'moment-timezone'
import { findIana } from 'windows-iana'
import { allTimezones, useTimezoneSelect } from 'react-timezone-select'
import stick from '../../../../../images/common/stick.png'
import { text } from '../../Constants'
import { DIVIDER, MAT_MOUD_TEXT } from '../../../../../utils/constants'
import upIcon from '../../../../../images/common/chevronUp.png'
import { generateVisitTableRowStatus } from '../../../../../utils/VisitsCommon'
import { visitText } from './Constants'
import { getTimeZones } from '../../../../../utils/common'
import { getVisitTypeIconProps } from '../../../../../utils/getVisitTypeIconProps'
import { getVisitTypeLabel } from '../../../../../utils/getVisitTypeLabel'
import { ProgramVisitBadge } from 'components/program-visit-badge/ProgramVisitBadge'
import { readVisitCoverage } from '@quickmd-llc/frontend-utils'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const VisitCard = ({ id, visit, showStatus, onClickArrowAction }) => {
  const provider =
    visit.Provider ?
      `${visit.Provider.Prefix ? `${visit.Provider.Prefix} ` : ''}${visit.Provider.FirstName} ${
        visit.Provider.LastName
      }${visit.Provider.Suffix ? ` ${visit.Provider.Suffix}` : ''}`
    : 'Unassigned'
  const timezones = getTimeZones(allTimezones)
  const { parseTimezone } = useTimezoneSelect({ timezones, labelStyle: 'abbrOnly' })
  const ianaTimezone = visit.TimeZone ? findIana(visit.TimeZone)?.[0] : undefined

  const toolTipStyle = {
    left: '0px',
    right: '0px',
    width: 'max-content',
    maxWidth: '90%',
    wordBreak: 'break-all',
    margin: 'auto',
    zIndex: 900000,
    pointerEvents: 'none',
  }

  return (
    <div className='visit-card-container' id={id}>
      <div className='visit-card-header-wrapper'>
        <FullTextToolTip
          id={`${id}-provider`}
          fullText={provider}
          extraStyle={{
            bottom: 55,
            ...toolTipStyle,
          }}
          view={
            <span id={`${id}-provider`} className='visit-card-provider-name bold'>
              <div />
              {provider}
            </span>
          }
        />
        {/* The provider name is `width: calc(100% - 16px)` with an ellipsis, so it
            shrinks to make room for the chip rather than pushing the chevron off. */}
        <ProgramVisitBadge className='shrink-0 self-start' coverage={readVisitCoverage(visit)} />
        {onClickArrowAction ?
          <img
            role='presentation'
            id='arrowRight'
            className='visit-card-arrow-right-icon'
            src={upIcon}
            alt={DIVIDER}
            onClick={onClickArrowAction}
          />
        : null}
      </div>
      <FullTextToolTip
        id={`${id}-date`}
        fullText={`${moment(visit.VisitDateTime).format('MMM DD YYYY, h:mma')} (${text.PATIENT} ${
          ianaTimezone ?
            moment.utc(visit.VisitDateTime).tz(ianaTimezone).format('MMM DD YYYY, h:mma ') +
            parseTimezone(
              ianaTimezone,
              moment(visit.VisitDateTime).utc(visit.VisitDateTime).tz(ianaTimezone).format('YYYY-MM-DD'),
              moment.utc(visit.VisitDateTime).tz(ianaTimezone).format('h:mma'),
            ).label
          : visitText.UNAVAILABLE
        })`}
        extraStyle={{
          bottom: 50,
          ...toolTipStyle,
        }}
        view={
          <span id={`${id}-date`} className='visit-card-name-label'>
            <div />
            {moment(visit.VisitDateTime).format('MMM DD YYYY, h:mma')} ({text.PATIENT}{' '}
            {ianaTimezone ?
              moment.utc(visit.VisitDateTime).tz(ianaTimezone).format('MMM DD YYYY, h:mma ') +
              parseTimezone(
                ianaTimezone,
                moment(visit.VisitDateTime).utc(visit.VisitDateTime).tz(ianaTimezone).format('YYYY-MM-DD'),
                moment.utc(visit.VisitDateTime).tz(ianaTimezone).format('h:mma'),
              ).label
            : visitText.UNAVAILABLE}
            )
          </span>
        }
      />

      <div className='visit-card-row-container'>
        {/* eslint-disable-next-line jsx-a11y/alt-text */}
        <img {...getVisitTypeIconProps(visit?.Method)} className='visit-card-type-icon' />
        <FullTextToolTip
          id={`${id}-service`}
          fullText={visit.ServiceTypeName}
          extraStyle={{
            bottom: 15,
            ...toolTipStyle,
          }}
          view={
            <div className='visit-card-text-container'>
              <span id={`${id}-service`} className='visit-card-name-label'>
                <div />
                {visit.ServiceTypeName}
              </span>
            </div>
          }
        />
        <img src={stick} alt={DIVIDER} className='video-call-room-visit-stick-icon' id='stick' />
        <FullTextToolTip
          id={`${id}-visit-type`}
          fullText={getVisitTypeLabel(visit.VisitTypeName, visit.Method)}
          extraStyle={{
            bottom: 15,
            ...toolTipStyle,
          }}
          view={
            <div className='visit-card-text-container'>
              <span id={`${id}-visit-type`} className='visit-card-name-label'>
                <div />
                {getVisitTypeLabel(visit.VisitTypeName, visit.Method)}
              </span>
            </div>
          }
        />
        {visit.IsMedicationAssistedTreatment ?
          <>
            <img src={stick} alt={DIVIDER} className='video-call-room-visit-stick-icon' id='stick' />
            <div className='visit-card-text-container'>
              <span id={`${id}-visit-type`} className='visit-card-name-label'>
                <div />
                {MAT_MOUD_TEXT}
              </span>
            </div>
          </>
        : null}
      </div>
      {showStatus ?
        <FullTextToolTip
          id={`${id}-status`}
          fullText={generateVisitTableRowStatus(visit?.Status)}
          extraStyle={{
            bottom: 15,
            ...toolTipStyle,
          }}
          view={
            <div className='visit-card-status-container'>
              <span id={`${id}-status`} className='visit-card-name-label'>
                <div />
                Status: {generateVisitTableRowStatus(visit?.Status)}
              </span>
            </div>
          }
        />
      : null}
    </div>
  )
}
